import { render, staticRenderFns } from "./signSet.vue?vue&type=template&id=48639eb6&scoped=true&"
import script from "./signSet.vue?vue&type=script&lang=js&"
export * from "./signSet.vue?vue&type=script&lang=js&"
import style0 from "./signSet.vue?vue&type=style&index=0&id=48639eb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48639eb6",
  null
  
)

export default component.exports